'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';
import { CartItemFlexField } from './cart-item-flex-field.component';
import { CartItemStandaloneField } from './cart-item-standalone-field.component';

import { CartItem } from '@/types/cart.types';
import { formatCartItemScheduleLabel } from '@/utils/cart/format-cart-item-schedule.util';
import { isFlexCartItem } from '@/utils/cart/is-flex-cart-item.util';
import { isStandaloneCartItem } from '@/utils/cart/is-standalone-cart-item.util';

interface CartItemScheduleFieldProps {
  item: CartItem;
  onEditSchedule?: () => void;
}

export function CartItemScheduleField({ item, onEditSchedule }: CartItemScheduleFieldProps) {
  if (isStandaloneCartItem(item)) {
    return <CartItemStandaloneField item={item} />;
  }

  if (isFlexCartItem(item)) {
    return <CartItemFlexField />;
  }

  const schedule = formatCartItemScheduleLabel(item);

  if (!schedule) {
    return null;
  }

  return (
    <CartItemField
      label="Data e hora"
      value={<span>{schedule}</span>}
      dataTestId={DataTestIdEnum.CART_ITEM_FIELD_SCHEDULE}
      action={onEditSchedule && {
        label: 'Alterar data e hora',
        dataTestId: DataTestIdEnum.CART_ITEM_EDIT_SCHEDULE_BUTTON,
        onClick: onEditSchedule,
      }}
    />
  );
}
